import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import api from '@/lib/api';

let cachedTeamName = null;

// Workspace › Project › Scene › Step — every level is a link back up
export function Breadcrumbs({ items }) {
  const navigate = useNavigate();
  const [teamName, setTeamName] = useState(cachedTeamName);
  useEffect(() => {
    if (cachedTeamName) return;
    api.get('/teams').then(r => { const t = (r.data || []).find(x => x.is_active); if (t) { cachedTeamName = t.name; setTeamName(t.name); } }).catch(() => {});
  }, []);
  const crumbs = [{ label: teamName || 'Workspace', to: '/dashboard' }, ...items];
  return (
    <nav data-testid="breadcrumbs" className="flex items-center gap-1 text-[11px] text-[#55555C] mb-3 flex-wrap min-w-0" aria-label="Breadcrumb">
      {crumbs.map((c, i) => {
        const last = i === crumbs.length - 1;
        return (
          <span key={i} className="flex items-center gap-1 min-w-0">
            {i > 0 && <ChevronRight className="w-3 h-3 shrink-0" />}
            {last || !c.to ? (
              <span data-testid={`crumb-${i}`} className={`truncate max-w-[220px] ${last ? 'text-[#c8c8d0]' : ''}`}>{c.label}</span>
            ) : (
              <button data-testid={`crumb-${i}`} onClick={() => navigate(c.to)} className="truncate max-w-[220px] hover:text-white transition-colors">{c.label}</button>
            )}
          </span>
        );
      })}
    </nav>
  );
}
